import { render } from "./HomePricing.vue?vue&type=template&id=57c6eed2"
import script from "./HomePricing.vue?vue&type=script&lang=js"
export * from "./HomePricing.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__